import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useCourse } from '../hooks/useCourse';
import { useAuth } from '../hooks/useAuth';
import { AudioPlayer } from './AudioPlayer';
import { logActivity } from '../lib/supabase';

export function Lesson() {
  const { courseId, lessonId } = useParams<{ courseId: string; lessonId: string }>();
  const { course, isLoading } = useCourse(courseId || '');
  const { user } = useAuth();

  // Log lesson view
  useEffect(() => {
    if (user?.id && courseId && lessonId) {
      logActivity(user.id, 'lesson', {
        course_id: courseId,
        lesson_id: lessonId,
        duration_minutes: 1,
      });
    }
  }, [user?.id, courseId, lessonId]);

  if (isLoading) {
    return <div className="loading">Laden...</div>;
  }

  const lesson = course?.lessons.find((l) => l.id === lessonId);

  if (!lesson) {
    return (
      <div className="error-state">
        <p>Lektion nicht gefunden</p>
        <Link to={`/course/${courseId}/lessons`}>Zurück</Link>
      </div>
    );
  }

  return (
    <div className="lesson-view">
      <Link to={`/course/${courseId}/lessons`} className="back-link">
        <ArrowLeft size={18} />
        Zurück
      </Link>

      <h1>{lesson.title}</h1>

      <AudioPlayer files={lesson.audioFiles} />

      <div className="transcript">
        <h2>Transkript</h2>
        <p style={{ whiteSpace: 'pre-line' }}>{lesson.transcript}</p>
      </div>
    </div>
  );
}
